<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card flat border>
                    <v-card-title class="d-flex align-center pe-2">
                        <v-icon icon="mdi-remote-desktop"></v-icon> &nbsp;
                        Connexions à distance
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>Les connexions sont accessibles seulement en utilisant le réseau sécurisé de la
                        pharmacie, ou à la maison via VPN.<br>Le code des connexions est 12.</v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-list density="compact">
                            <v-list-item v-for="(connexion, i) in connexions" :key="i"
                                @click="openConnexion(connexion)">
                                <template v-slot:prepend>
                                    <v-icon icon="mdi-remote-desktop"></v-icon>
                                </template>
                                <v-list-item-title>{{ connexion.nom }} <small>
                                        {{ connexion.link }}</small></v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import $axios from "../plugins/axios";

export default {
    data: () => ({
        connexions: [],
    }),
    mounted() {
        this.fetchConnexion()
    },
    methods: {
        fetchConnexion() {
            $axios.get(`${process.env.VUE_APP_API_URL}/poste_vnc_list`)
            .then((response) => {
                this.connexions = response.data.map((el) => {
                    return {
                        link: "vnc://" + el.ip + ":"+el.port,
                        ...el,
                    }
                }).sort((a, b) => {
                    if (a.nom < b.nom) return -1;
                    if (a.nom > b.nom) return 1;
                    return 0;
                })
            })
            .catch((err) => console.log(err))  
        },
        openConnexion(connexion) {
            window.open(connexion.link, '_blank');
        }
    },
};
</script>